
function errorNode(item, idx) {
	
	let node = {
			id: `${item.id}-${idx}-node`,
			name: item.prompt,
			nameVisible: true
		},
		block = {
			type: "@tripetto/block-error",
			version: "5.0.4"
		};

	if (item.description !== null && item.description !== '') {
		node.description = item.description;
	}

	return {
		...node,
		block
	};
}

export default errorNode;